<script setup>
import { useI18n } from 'vue-i18n'
import { usePlanningStore } from '@/stores/planning.store'
import { useChips } from '@/composables/chips'
import { useRateCard } from '@/composables/rate-card'
import ListItem from '@/components/shared/ListItem.vue'

defineProps({
  equipment: {
    type: Object,
    required: true,
  },
})

const { t } = useI18n()
const planningStore = usePlanningStore()
const { getTagChips, needQrScanChip, isVehicleChip, isSerializedChip, getServiceStructureTypeChip, getConditionChips, archivedChip } = useChips()
const { priceLabel } = useRateCard()

const getLabel = (e) => planningStore.getServiceName(e, false, true)

const getSerial = (e) =>
  [e.serial_number, e.internal_serial].filter(Boolean).join(' / ') || undefined

const getSerialChip = (e) => {
  const serial = getSerial(e)
  if (serial) return { ...isSerializedChip, name: serial, label: serial }
  return e.is_serialized ? isSerializedChip : null
}

const getCaptionChips = (e) => [
  ...(e.warehouse_name ? [{ name: e.warehouse_name, label: e.warehouse_name, color: 'blue-grey', textColor: 'white', size: 'sm' }] : []),
  ...getServiceStructureTypeChip(e.structure_type),
  getSerialChip(e),
  ...getTagChips(e.tags),
].filter(Boolean)

const getRightCaptionChips = (e) => getConditionChips(e.condition_value)

const getRightChips = (e) => {
  const chips = []
  if (e.is_rented)      chips.push({ name: t('common.rented'), color: 'grey', size: 'sm' })
  if (e.archived)       chips.push(archivedChip)
  if (e.need_qr_scan)   chips.push(needQrScanChip)
  if (e.is_vehicle)     chips.push(isVehicleChip)
  return chips
}
</script>

<template>
  <list-item
    v-bind="$attrs"
    :avatar="equipment.avatar_file || equipment.avatar_url"
    avatar-icon="mdi-camera-outline"
    :label="getLabel(equipment)"
    :caption-chips="getCaptionChips(equipment)"
    :right-label="priceLabel(equipment, true)"
    :right-caption-chips="getRightCaptionChips(equipment)"
    :right-chips="getRightChips(equipment)"
    :disabled="equipment.archived"
  >
    <template v-if="$slots.avatar" #avatar>
      <slot name="avatar" />
    </template>
    <template v-if="$slots.right" #right>
      <slot name="right" />
    </template>
  </list-item>
</template>
